/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Dashboard_BrandInputs */

const en_company_dashboard_brand = /** @type {(inputs: Company_Dashboard_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Week`)
};

const de_company_dashboard_brand = /** @type {(inputs: Company_Dashboard_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Week`)
};

/**
* | output |
* | --- |
* | "Matching Week" |
*
* @param {Company_Dashboard_BrandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_dashboard_brand = /** @type {((inputs?: Company_Dashboard_BrandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Dashboard_BrandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_dashboard_brand(inputs)
	return en_company_dashboard_brand(inputs)
});